import { css } from 'lit';

export default css`
  :host {
    display: block;
    position: relative;
    background: var(--webmodule-panel-background-color);
    border: solid var(--webmodule-panel-border-width) var(--webmodule-panel-border-color);
    border-radius: var(--webmodule-border-radius-medium);
    padding: var(--webmodule-spacing-x-small) 0;
    overflow: auto;
    overscroll-behavior: none;
  }

  ::slotted(webmodule-divider) {
    --spacing: var(--webmodule-spacing-x-small);
  }
`;
